import Vue from "vue";
import Router from "vue-router";
import Login from "@/modules/auth/Login";
import RecoveryPassword from "@/modules/auth/RecoveryPassword";
import ChangePassword from "@/modules/auth/ChangePassword";
import Register from "@/modules/auth/Register";
import CanceledAccount from "@/modules/auth/CanceledAccount";
import Onboarding from "@/modules/onboarding/Onboarding";
import SelectPlan from "@/modules/onboarding/SelectPlan";
import ConfigIntegration from "@/modules/config/Integration";
import ConfigUser from "@/modules/config/User";
import ConfigAccount from "@/modules/config/Account";
import HowTo from "@/modules/howto/HowTo";
import FacebookAds from "@/modules/oauth/FacebookAds";
import GoogleAds from "@/modules/oauth/GoogleAds";
import TikTokAds from "@/modules/oauth/TikTokAds";
import LoginOauth from "@/modules/oauth/LoginOauth";
import Canny from "@/modules/canny/Canny";

import Report from "@/modules/report/Report";
import Campaign from "@/modules/campaign/Campaign";
import CampaignDetail from "@/modules/campaign/Detail";
import CampaignNew from "@/modules/campaign/New";
import CampaignEdit from "@/modules/campaign/Edit";


import Contact from "@/modules/contact/Contact";
import ContactDetail from "@/modules/contact/Detail";
import ContactNew from "@/modules/contact/New";
import ContactEdit from "@/modules/contact/New";

import Pipeline from "@/modules/pipeline/Pipeline";

import Automation from "@/modules/automation/Automation";
import AutomationDetail from "@/modules/automation/Detail";
import AutomationNew from "@/modules/automation/New";
import AutomationEdit from "@/modules/automation/Edit";

import RemovedContact from "@/modules/removedContact/RemovedContact";

import Home from "@/modules/Home";
import Account from "@/modules/auth/Account";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
    },
    {
      path: "/recovery-password",
      name: "RecoveryPassword",
      component: RecoveryPassword,
    },
    {
      path: "/change-password/:rtoken",
      name: "ChangePassword",
      component: ChangePassword,
      props: true,
      meta: {
        breadcrumb: [
          {
            name: "Trocar a senha"
          }
        ]
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/onboarding",
      name: "Onboarding",
      component: Onboarding,
    },
    {
      path: "/onboarding-flow",
      name: "SelectPlan",
      component: SelectPlan,
    },
    {
      path: "/conta-cancelada",
      name: "CanceledAccount",
      component: CanceledAccount,
    },
    {
      path: "/tutoriais",
      name: "HowTo",
      component: HowTo,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Tutoriais",
          },
        ],
      },
    },
    {
      path: "/sugestoes",
      name: "Canny",
      component: Canny,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Sugestões",
          },
        ],
      },
    },
    {
      path: "/config/integracoes/",
      name: "ConfigIntegration",
      component: ConfigIntegration,
      meta: {
        requiresLogin: true,
        permissionName: "config", // FIXME: arrumar permissão depois
        breadcrumb: [
          {
            name: "Configurações",
          },
          {
            name: "Integrações",
            link: "ConfigIntegration",
          },
        ],
      },
    },
    {
      path: "/config/integracoes/:slug",
      name: "ConfigIntegrationDetail",
      component: ConfigIntegration,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "config", // FIXME: arrumar permissão depois
        breadcrumb: [
          {
            name: "Configurações",
          },
          {
            name: "Integrações",
            link: "ConfigIntegration",
          },
        ],
      },
    },
    {
      path: "/config/usuarios",
      name: "ConfigUser",
      component: ConfigUser,
      meta: {
        requiresLogin: true,
        permissionName: "config", // FIXME: arrumar permissão depois
        breadcrumb: [
          {
            name: "Configurações",
          },
          {
            name: "Usuários",
          },
        ],
      },
    },
    {
      path: "/config/conta",
      name: "ConfigAccount",
      component: ConfigAccount,
      meta: {
        requiresLogin: true,
        permissionName: "config", // FIXME: arrumar permissão depois
        breadcrumb: [
          {
            name: "Configurações",
          },
          {
            name: "Conta",
          },
        ],
      },
    },
    {
      path: "/conta",
      name: "Account",
      component: Account,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Escolher conta",
          },
        ],
      },
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "Home",
          },
        ],
      },
    },
    {
      path: "/oauth2/facebook-ads/success",
      name: "FacebookAdsSelectAccounts",
      component: FacebookAds,
    },
    {
      path: "/oauth2/google-ads/success",
      name: "GoogleAdsSelectAccounts",
      component: GoogleAds,
    },
    {
      path: "/oauth2/tiktok-ads/success",
      name: "TikTokAdsAdsSelectAccounts",
      component: TikTokAds,
    },
    {
      path: "/oauth2/facebook/login",
      name: "LoginOauthFB",
      component: LoginOauth,
    },
    {
      path: "/oauth2/google/login",
      name: "LoginOauthG",
      component: LoginOauth,
    },
    {
      path: "/dash",
      name: "Report",
      component: Report,
      meta: {
        requiresLogin: true,
        permissionName: "report",
        breadcrumb: [
          {
            name: "Dashboard",
          },
        ],
      },
    },
    {
      path: "/campaign",
      name: "Campaign",
      component: Campaign,
      meta: {
        requiresLogin: true,
        permissionName: "campaign",
        breadcrumb: [
          {
            name: "Campanhas",
          },
        ],
      },
    },
    {
      path: "/campaign/:campaign_id",
      name: "CampaignDetail",
      component: CampaignDetail,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "campaign",
        breadcrumb: [
          {
            name: "Campanhas",
            link: "Campaign"
          },
          {
            name: "Name",
          },
        ],
      },
    },
    {
      path: "/campaign-new/",
      name: "CampaignNew",
      component: CampaignNew,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "campaign",
        breadcrumb: [
          {
            name: "Campanhas",
            link: "Campaign"
          },
          {
            name: "Nova Campanha",
          },
        ],
      },
    },
    {
      path: "/campaign-edit/:campaign_id",
      name: "CampaignEdit",
      component: CampaignEdit,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "campaign",
        breadcrumb: [
          {
            name: "Campanhas",
            link: "Campaign"
          },
          {
            name: "Editar Campanha",
          },
        ],
      },
    },
    {
      path: "/pipeline",
      name: "Pipeline",
      component: Pipeline,
      meta: {
        requiresLogin: true,
        breadcrumb: [
          {
            name: "CRM Pipelines",
          },
        ],
      },
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      meta: {
        requiresLogin: true,
        permissionName: "contact",
        breadcrumb: [
          {
            name: "Contatos",
          },
        ],
      },
    },
    {
      path: "/contact/:contact_id",
      name: "ContactDetail",
      component: ContactDetail,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "contact",
        breadcrumb: [
          {
            name: "Contatos",
            link: "Contact"
          },
          {
            name: "ID",
          },
        ],
      },
    },
    {
      path: "/contact-new/",
      name: "ContactNew",
      component: ContactNew,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "contact",
        breadcrumb: [
          {
            name: "Contatos",
            link: "Contact"
          },
          {
            name: "Novo Contato",
          },
        ],
      },
    },
    {
      path: "/contact-edit/:contact_id",
      name: "ContactEdit",
      component: ContactEdit,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "contact",
        breadcrumb: [
          {
            name: "Contatos",
            link: "Contact"
          },
          {
            name: "Editar Contato",
          },
        ],
      },
    },
    {
      path: "/automation",
      name: "Automation",
      component: Automation,
      meta: {
        requiresLogin: true,
        permissionName: "automation",
        breadcrumb: [
          {
            name: "Automações",
          },
        ],
      },
    },
    {
      path: "/automation/:automation_id",
      name: "AutomationDetail",
      component: AutomationDetail,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "automation",
        breadcrumb: [
          {
            name: "Automações",
            link: "Automation"
          },
          {
            name: "ID",
          },
        ],
      },
    },
    {
      path: "/automation-new/",
      name: "AutomationNew",
      component: AutomationNew,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "automation",
        breadcrumb: [
          {
            name: "Automações",
            link: "Automation"
          },
          {
            name: "Nova Automação",
          },
        ],
      },
    },
    {
      path: "/automation-edit/:automation_id",
      name: "AutomationEdit",
      component: AutomationEdit,
      props: true,
      meta: {
        requiresLogin: true,
        permissionName: "automation",
        breadcrumb: [
          {
            name: "Automações",
            link: "Automation"
          },
          {
            name: "Editar Automação",
          },
        ],
      },
    },
    {
      path: "/removed-contact/:accId/:hash",
      name: "RemovedContactList",
      component: RemovedContact,
      props: true,
    },
    {
      path: "*",
      name: "route.notfound",
      redirect: "/home",
    },
  ],
});
